// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xdpp","importantInfo":"styles_importantInfo__2bhBC"};